import React, { useEffect, useState } from 'react';
import { Instagram, Linkedin, Facebook, Youtube } from 'lucide-react';
import { api } from '../../App';

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.5 3c.3 2.2 1.6 3.6 3.9 3.8v3.3c-1.4.1-2.7-.3-3.9-1.1v6.4c0 3.6-2.5 5.6-5.4 5.6A5.3 5.3 0 0 1 5.7 15.7c0-3.4 2.9-5.7 6.2-5.3v3.4c-1.5-.4-3 .5-3 2.1 0 1.2.9 2.1 2.1 2.1 1.3 0 2.1-.9 2.1-2.4V3h3.4Z" />
  </svg>
);
export const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.8 3h3.1l-6.8 7.8L22 21h-6.2l-4.9-6.4L5.3 21H2.2l7.3-8.3L2 3h6.4l4.4 5.8L17.8 3Zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5Z" />
  </svg>
);

export const SOCIAL_META = {
  instagram: { label: 'Instagram', Icon: Instagram },
  tiktok: { label: 'TikTok', Icon: TikTokIcon },
  linkedin: { label: 'LinkedIn', Icon: Linkedin },
  x: { label: 'X', Icon: XIcon },
  facebook: { label: 'Facebook', Icon: Facebook },
  youtube: { label: 'YouTube', Icon: Youtube },
};

// Footer icon row — renders only the profiles set in Studio → Social links.
export default function SocialLinks({ className = '' }) {
  const [links, setLinks] = useState({});
  useEffect(() => {
    api.get('/kes-blog/public/social').then((r) => setLinks(r.data || {})).catch(() => {});
  }, []);
  const entries = Object.entries(links).filter(([k, v]) => v && SOCIAL_META[k]);
  if (entries.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-links">
      {entries.map(([k, href]) => {
        const { label, Icon } = SOCIAL_META[k];
        return (
          <a key={k} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Kewl on ${label}`} title={label}
            className="w-9 h-9 rounded-full border border-[#EDE4D6] flex items-center justify-center text-[#5C554E] hover:text-[#FDFBF7] hover:bg-[#4A3C31] hover:border-[#4A3C31] transition-colors"
            data-testid={`social-link-${k}`}>
            <Icon className="w-4 h-4" strokeWidth={1.5} />
          </a>
        );
      })}
    </div>
  );
}
